import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { FormControl, InputLabel } from '@mui/material';

import Button from '../Button/Button';
import { Dialog } from '../Dialog/Dialog';
import { isMobile, isOnlyMobile } from '../../services/isMobile';
import Select from '../Select/Select';
import MenuItem from '../MenuItem/MenuItem';
import APIClient from '../../services/APIClient';

import './_styles.scss';
import { emptyQuery, OPERATOR_NAMES } from '../AdvancedSearch/QueryBuilder/constants';
import { getChargersAdvancedSearchConfig } from '../../../screens/ChargersList/constants';
import { transformQueryOut } from '../AdvancedSearch/QueryBuilder/utils';
import { fillChargersFilter } from '../AdvancedSearch/utils';
import { getUser } from '../../../screens/Login/selectors';
import { isDirectlySupervisor } from '../../services/HasAccess';

const dialogActionsStyle = {
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  position: 'relative',
  alignItems: 'normal',
};

const paperStyle = {
  width: 600,
};

export default ({ disabled, chargerId, listId }) => {
  const [isShowConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const user = useSelector(getUser);
  const listProps = useSelector((state) => get(state, `ssplists.${listId}`, {}));

  useEffect(() => {
    if (!isDirectlySupervisor(user)) {
      return;
    }

    APIClient.get('/customers')
      .then(({ data: { payloads } }) => {
        setCustomers(
          payloads
            .map(({ customerId, customerName }) => ({
              customerId,
              customerName,
            }))
            .sort((a, b) => a.customerName.localeCompare(b.customerName)),
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleCloseDialog = () => {
    setShowConfirmDialog(false);
  };

  const handleSelectCustomer = (e) => {
    setSelectedCustomer(e.target.value);
  };

  const handleTransferDevices = () => {
    handleCloseDialog();

    if (listId) {
      const { selectAll, selectedDataIds, filterQuery, filter } = listProps;
      let filterBy = transformQueryOut([filterQuery || emptyQuery], getChargersAdvancedSearchConfig())[0];

      if (!selectAll) {
        filterBy = {
          operator: 'AND',
          conditions: [
            {
              field: 'c_uuids',
              operator: OPERATOR_NAMES.anyOf,
              value: selectedDataIds,
            },
          ],
        };
      } else if (filter) {
        fillChargersFilter(filter, filterBy);
      }

      APIClient.post('/devices/transfer', {
        targetCustomerId: selectedCustomer,
        filter: {
          filter_by: filterBy,
        },
      }).catch((error) => {
        console.error(error);
      });
    } else if (chargerId) {
      APIClient.post(`/devices/${chargerId}/transfer`, {
        targetCustomerId: selectedCustomer,
      }).catch((error) => {
        console.error(error);
      });
    }
  };

  const renderDialogFooter = () => {
    const actions = [
      <Button key="cancel-btn" color="primary" variant="text" onClick={handleCloseDialog}>
        Cancel
      </Button>,
      <Button key="transfer-btn" color="primary" variant="text" onClick={handleTransferDevices} disabled={!selectedCustomer}>
        Transfer
      </Button>,
    ];

    return <div className="transfer-dialog-actions-wrapper">{actions}</div>;
  };

  return (
    <>
      {isDirectlySupervisor(user) && (
        <Button disabled={disabled} className="transfer-button" onClick={() => setShowConfirmDialog(true)}>
          Transfer
        </Button>
      )}

      <Dialog
        className={`transfer-dialog ${isOnlyMobile ? 'mobile' : ''}`}
        actions={renderDialogFooter()}
        open={isShowConfirmDialog}
        onClose={handleCloseDialog}
        contentClassName="transfer-modal"
        maxWidth={false}
        actionsStyle={dialogActionsStyle}
        paperProps={{
          style: paperStyle,
        }}
        disablePortal
        title="Transfer"
      >
        <FormControl fullWidth>
          <InputLabel shrink>Target Customer Name</InputLabel>
          <Select
            className={`transfer-customer-select ${isMobile ? 'mobile' : ''}`}
            menuClassName="transfer-customer-select-menu"
            value={selectedCustomer}
            onChange={handleSelectCustomer}
          >
            {customers.map(({ customerName: title, customerId: value }) => (
              <MenuItem key={value} value={value} title={title}>
                {title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <div className="transfer-customer-list-wrapper">
          <p>Please keep in mind that this action won't affect charger(s) that:</p>
          <ul className="transfer-customer-list">
            <li>have FW Update status "In Progress"</li>
            <li>have active Charging Session</li>
            <li>have Configuration Parameters in “Changes Pending" or “Reboot Required“ states</li>
            <li>have Plaza Name populated</li>
            <li>have Сustomer Name same as the selected Target Custom Name </li>
            <li>charger is Offline</li>
          </ul>
        </div>
      </Dialog>
    </>
  );
};
